import { toast } from 'sonner';
import type { TFunction } from 'i18next';
import { onApiResponse } from '../lib/api.ts';
import { webBuild } from '../lib/build.ts';

/**
 * Shows "A new version is available" once when the server reports another
 * version than this web build (app-about spec, Stale client detection).
 */
export function watchForNewVersion(
  t: TFunction,
  current: string = webBuild.version,
  reload: () => void = () => window.location.reload(),
): () => void {
  let shown = false;
  return onApiResponse((response) => {
    const server = response.headers.get('x-app-version');
    if (shown || !server || current === 'dev' || server === current) return;
    shown = true;
    toast(t('stale.message'), { duration: Infinity, action: { label: t('common.reload'), onClick: reload } });
  });
}
